import React from 'react'
import * as styles from './index.module.css'
import Link from '../Link'
import { GradientBorder } from '../commons'

const GenericTextWithTitle = (props) => {
  const subtitleElements = props.subtitle.subtitle.split('\n')
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 767

  return (
    <div className="wrapper">
      <div className={styles.container}>
        <h1 className={styles.title}>{props.title}</h1>
        <div className={styles.subtitle}>
          <span>{subtitleElements[0]}</span>
          <Link
            to={subtitleElements[1].split(';')[0]}
            children={
              <React.Fragment>
                {isMobile && (
                  <div className={styles.link}>
                    {' ' + subtitleElements[1].split(';')[1]}
                  </div>
                )}
                {!isMobile && (
                  <span className={styles.link}>
                    {' ' + subtitleElements[1].split(';')[1]}
                  </span>
                )}
              </React.Fragment>
            }
          ></Link>
        </div>
      </div>
    </div>
  )
}

export default GenericTextWithTitle
